var _style, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgClockIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48.1 40.5",
    style: {
      enableBackground: "new 0 0 48.1 40.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#137EBB;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,0C12.9,0,3.8,9.1,3.8,20.2S12.9,40.5,24,40.5c11.2,0,20.2-9.1,20.2-20.2S35.2,0,24,0z M24,37.8 c-9.7,0-17.5-7.9-17.5-17.5S14.4,2.7,24,2.7c9.7,0,17.6,7.9,17.6,17.6S33.7,37.8,24,37.8z M25.7,19.7l6.7,5.4c0.6,0.5,0.7,1.4,0.2,2 c-0.3,0.4-0.7,0.5-1.1,0.5c-0.3,0-0.6-0.1-0.9-0.3l-7.2-5.8c-0.3-0.3-0.5-0.7-0.5-1.1V8.9c0-0.8,0.7-1.4,1.4-1.4 c0.8,0,1.4,0.7,1.4,1.4V19.7z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClockIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clock-icon.ad11d9cd.svg";
export { ForwardRef as ReactComponent };